import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '@services/user.service';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@shared/services/loader.service';
import { ToastService } from '../../services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@services/storage.service';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';


@Component({
  standalone: false,
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  currentUser;
  currentUserForm: UntypedFormGroup;
  passwordForm: UntypedFormGroup;

  loading = false;
  isUserSubmitted = false;
  isPasswordSubmitted = false;

  passwordsMatch: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const p1 = control.get('newPassword')?.value;
    const p2 = control.get('newPasswordConfirmation')?.value;

    if (!p1 || !p2) return null;
    return p1 === p2 ? null : { passwordMismatch: true };
  };



  @ViewChild('pform') passForm;

  constructor(
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private loader: LoaderService,
    private toastService: ToastService,
    private translateService: TranslateService,
    private storageService: StorageService,

  ) {
    this.currentUserForm = this.formBuilder.group({
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      role: ['', Validators.required],
      registerDate: ['', Validators.required]
    });


    this.passwordForm = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      newPasswordConfirmation: ['', [Validators.required, Validators.minLength(6)]],
    },
      { validators: this.passwordsMatch }
    );
  }

  get currentUserControls() { return this.currentUserForm.controls; }
  get passwordControls() { return this.passwordForm.controls; }

  ngOnInit() {
    // this.loader.showLoader();
    this.getCurrentUser();
  }



  getCurrentUser() {
    this.userService.getCurrentUser().subscribe(
      response => {
        this.currentUser = response;
        this.updateCurrentUserForm();
        //console.log("Usuario activo ---> ", this.currentUser);
        // this.loader.hideLoader();
      },
      error => console.log(error)
    );
  }

  updateCurrentUserForm() {
    this.currentUserForm.controls.name.setValue(this.currentUser.name);
    this.currentUserForm.controls.lastname.setValue(this.currentUser.lastname);
    this.currentUserForm.controls.phone.setValue(this.currentUser.phone);
    this.currentUserForm.controls.email.setValue(this.currentUser.email);
    this.currentUserForm.controls.email.disable();
    this.currentUserForm.controls.role.setValue(this.currentUser.role.name);
    this.currentUserForm.controls.role.disable();
    this.currentUserForm.controls.registerDate.setValue(this.currentUser.registerDate);
    this.currentUserForm.controls.registerDate.disable();
  }

  submitCurrentUser() {
    this.isUserSubmitted = true;
    if (this.currentUserForm.valid) {
      const userUpdated = this.buildUpdatedUserObject();
      this.userService.updateCurrentUser(userUpdated).subscribe(
        response => {
          this.getCurrentUser();
          this.isUserSubmitted = false;

          this.updateUserNameInStorage(userUpdated.name, userUpdated.lastname);
          this.toastService.successToast(this.translateService.instant('users.userUpdateOk'));
        },
        error => {
          this.isUserSubmitted = false;
          this.toastService.errorToast(this.translateService.instant('users.userUpdateError'));
          console.log("Error updating current user ---> ", error)
        }
      );
    } else {
      this.isUserSubmitted = false;
      this.toastService.errorToast(this.translateService.instant('users.userUpdateFormError'));
      console.log("Formulario no válido, no se puede enviar");
    }
  }

  public updateUserNameInStorage(name: string, lastname: string): void {
    const fullName = `${name} ${lastname}`;
    this.storageService.set('userName', fullName);
  }


  submitPasswordForm() {
    this.isPasswordSubmitted = true;
    this.passwordForm.markAllAsTouched();

    // si hay mismatch, toast específico y salimos
    if (this.passwordForm.hasError('passwordMismatch')) {
      this.toastService.errorToast(this.translateService.instant('users.passwordMatchError'));
      this.isPasswordSubmitted = false;
      return;
    }

    // si hay otros errores (required/minlength), no toast genérico
    if (this.passwordForm.invalid) {
      this.isPasswordSubmitted = false;
      return;
    }


    if (this.passwordForm.valid) {
      if (this.passwordControls.newPassword.value == this.passwordControls.newPasswordConfirmation.value) {
        const passwordObject = {
          oldPassword: this.passwordControls.oldPassword.value,
          password: this.passwordControls.newPassword.value
        };
        this.userService.updateCurrentUser(passwordObject).subscribe(
          response => {
            this.toastService.successToast(this.translateService.instant('users.passwordUpdateOk'));
            this.passForm.resetForm();
            this.isPasswordSubmitted = false;
            // console.log(this.passwordForm);
          },
          error => {
            this.toastService.errorToast(this.translateService.instant('users.passwordUpdateError'));
            console.log("Error al cambiar la contraseña ---> ", error);
            this.isPasswordSubmitted = false;
          }
        )
      } else {
        this.toastService.errorToast(this.translateService.instant('users.passwordMatchError'));
        console.log("Los passwords no coinciden");
        this.isPasswordSubmitted = false;
      }
    } else {
      this.toastService.errorToast(this.translateService.instant('users.passwordFormError'));
      console.log("No se puede enviar el formulario de cambio de contraseña ---> ", this.passwordForm.errors);
      this.isPasswordSubmitted = false;
    }
  }

  buildUpdatedUserObject() {
    const currentUserUpdated = {
      name: this.currentUserForm.controls.name.value,
      lastname: this.currentUserForm.controls.lastname.value,
      phone: this.currentUserForm.controls.phone.value
    }

    return currentUserUpdated;
  }
}
